export type EditorToolbarFeature =
  | 'align'
  | 'backgroundColor'
  | 'fontSize'
  | 'indent'
  | 'link'
  | 'strikethrough'
  | 'table'
  | 'textColor';

export type EditorToolbarPreset = 'default' | 'description' | 'comment';

const PRESET_FEATURES: Record<EditorToolbarPreset, EditorToolbarFeature[]> = {
  default: [],
  description: [
    'align',
    'backgroundColor',
    'fontSize',
    'indent',
    'link',
    'strikethrough',
    'table',
    'textColor',
  ],
  comment: ['link'],
};

export const hasToolbarFeature = (
  preset: EditorToolbarPreset,
  feature: EditorToolbarFeature,
) => PRESET_FEATURES[preset].includes(feature);
